import { SortOrder } from '@price-for-profit/micro-services';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { GetDraftContractsResponse } from 'shared/services';
import { SortableDraftContractFields } from 'shared/types';
export interface GetDraftContractsProps {
  showTermOrTierChanges: boolean;
  showDeletionsOrRestorations: boolean;
  page?: number;
  pageSize?: number;
  sortOrder?: SortOrder;
  sortBy?: SortableDraftContractFields;
}

export function useQueryDraftContracts(props: GetDraftContractsProps) {
  const { draftContractService } = useService();
  const { data, isLoading, isFetching } = useQuery<GetDraftContractsResponse, Error>(['draft-contracts', props], () =>
    draftContractService.getDraftContracts(props.showTermOrTierChanges, props.showDeletionsOrRestorations, {
      page: props.page,
      pageSize: props.pageSize,
      sortOrder: props.sortOrder,
      sortBy: props.sortBy,
    })
  );

  return { draftContracts: data, isLoading, isFetching } as const;
}
